import React from 'react';
import './Footer.css';

import logoIcon from '../../assets/logo-icon.svg';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <div className="footer-logo">
            <img src={logoIcon} alt="IIIT Network Logo" />
          </div>
          <div>
            <h3>IIIT Network</h3>
            <p>Discover every branch across campus. Portfolios, passion projects, and college communities in one place.</p>
          </div>
        </div>

        <div className="site-footer__grid">
          <div>
            <h4>Explore</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/societies">Societies</a></li>
              <li><a href="/batches">Batches</a></li>
              <li><a href="/placement">Placement resources</a></li>
              <li><a href="/exams">Exam resources</a></li>
            </ul>
          </div>
          <div>
            <h4>Support</h4>
            <ul>
              <li><a href="mailto:hello@branchconnect.dev">Contact</a></li>
              <li><a href="/auth/forgot-password">Forgot password</a></li>
              <li><a href="/auth/sign-up">Join IIIT Network</a></li>
              <li><a href="/server-error" onClick={(e) => e.preventDefault()}>Status</a></li>
            </ul>
          </div>
          <div>
            <h4>Connect</h4>
            <ul className="footer-socials">
              <li><a href="https://www.linkedin.com" target="_blank" rel="noreferrer">LinkedIn</a></li>
              <li><a href="https://github.com/Priyanshukumaranand" target="_blank" rel="noreferrer">GitHub</a></li>
              <li><a href="https://www.instagram.com" target="_blank" rel="noreferrer">Instagram</a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noreferrer">X</a></li>
            </ul>
          </div>
        </div>

        <div className="site-footer__meta">
          <p>© {new Date().getFullYear()} IIIT Network. Crafted with passion for the next generation of campus innovators.</p>
          <div className="footer-links" aria-label="Footer links">
            <a href="/" onClick={(e) => e.preventDefault()}>Privacy</a>
            <a href="/" onClick={(e) => e.preventDefault()}>Terms</a>
            <a href="/" onClick={(e) => e.preventDefault()}>Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
